module.exports = __webpack_public_path__ + "static/img/manual-27.e4bf7aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-27.png
// module id = L4Xk
// module chunks = 4